import { render, staticRenderFns } from "./PressKit.vue?vue&type=template&id=40891a36&lang=pug&"
import script from "./PressKit.vue?vue&type=script&lang=js&"
export * from "./PressKit.vue?vue&type=script&lang=js&"
import style0 from "./PressKit.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports